export const scenarioNavItems = [
    { title: 'S1', subTitle: 'Negative client ROI w high RM revenue' },
    { title: 'S2', subTitle: 'Persistent dynamic suitability breaches' },
    { title: 'S3', subTitle: 'High number of execution only trades' },
    {
        title: 'S4',
        subTitle: 'High instances of concentrated execution only trades'
    }
];
